import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const MessageFilters = ({ 
  filters = {}, 
  onFilterChange = () => {},
  onClearFilters = () => {},
  className = '' 
}) => {
  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' },
    { value: 'year', label: 'This Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const messageTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'birthday', label: 'Birthday Wishes' },
    { value: 'random', label: 'Random Contact' },
    { value: 'manual', label: 'Manual Messages' },
    { value: 'scheduled', label: 'Scheduled Messages' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'delivered', label: 'Delivered' },
    { value: 'pending', label: 'Pending' },
    { value: 'failed', label: 'Failed' }
  ];

  const channelOptions = [
    { value: 'all', label: 'All Channels' },
    { value: 'email', label: 'Email' },
    { value: 'sms', label: 'SMS' },
    { value: 'whatsapp', label: 'WhatsApp' }
  ];

  const hasActiveFilters = Object.values(filters)?.some(value => 
    value && value !== 'all' && value !== ''
  );

  return (
    <div className={`bg-surface border border-border rounded-lg p-4 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-medium text-text-primary flex items-center space-x-2">
          <Icon name="Filter" size={18} />
          <span>Filters</span>
        </h3>
        
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear All
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Date Range Filter */}
        <Select
          label="Date Range"
          options={dateRangeOptions}
          value={filters?.dateRange || 'all'}
          onChange={(value) => onFilterChange({ ...filters, dateRange: value })}
          className="w-full"
        />

        {/* Message Type Filter */}
        <Select
          label="Message Type"
          options={messageTypeOptions}
          value={filters?.messageType || 'all'}
          onChange={(value) => onFilterChange({ ...filters, messageType: value })}
          className="w-full"
        />

        {/* Status Filter */}
        <Select
          label="Delivery Status"
          options={statusOptions}
          value={filters?.status || 'all'}
          onChange={(value) => onFilterChange({ ...filters, status: value })}
          className="w-full"
        />

        {/* Channel Filter */}
        <Select
          label="Channel"
          options={channelOptions}
          value={filters?.channel || 'all'}
          onChange={(value) => onFilterChange({ ...filters, channel: value })}
          className="w-full"
        />
      </div>
      {/* Active Filter Chips */}
      {hasActiveFilters && (
        <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-border">
          {Object.entries(filters)?.map(([key, value]) => {
            if (!value || value === 'all' || value === '') return null;
            
            const getFilterLabel = (filterKey, filterValue) => {
              switch (filterKey) {
                case 'dateRange':
                  return dateRangeOptions?.find(opt => opt?.value === filterValue)?.label || filterValue;
                case 'messageType':
                  return messageTypeOptions?.find(opt => opt?.value === filterValue)?.label || filterValue;
                case 'status':
                  return statusOptions?.find(opt => opt?.value === filterValue)?.label || filterValue;
                case 'channel':
                  return channelOptions?.find(opt => opt?.value === filterValue)?.label || filterValue;
                default:
                  return filterValue;
              }
            };

            return (
              <div
                key={key}
                className="flex items-center space-x-1 bg-primary/10 text-primary px-3 py-1 rounded-full text-sm"
              >
                <span>{getFilterLabel(key, value)}</span>
                <button
                  onClick={() => onFilterChange({ ...filters, [key]: '' })}
                  className="hover:bg-primary/20 rounded-full p-0.5 transition-micro"
                >
                  <Icon name="X" size={12} />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MessageFilters;